export default {
    close(state) {
        state.show = false;
    },
    show(state, param = {}) {
        let callback = param.callback;
        if(!callback) {
            callback = () => {};
        }
        Object.assign(state, param, {
            show: true,
            callback
        });
    },
};



// WEBPACK FOOTER //
// ./src/ui/alert/store/mutations.js